import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import Icon from '@material-ui/core/Icon/Icon';
import withStyles from '@material-ui/core/styles/withStyles';
import withWidth from '@material-ui/core/withWidth/withWidth';
import { Typography, Button, Grid } from '@material-ui/core';
import { withAlignTarget } from 'redhotmagma-visualization/AlignTargetProvider';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import Thumbnails from '../../Containers/Thumbnail';
import { CloseMenuIcon } from '../../../../../Icons';
import TitleDisplay from '../../../../Shared/Containers/TitleDisplay';

const getHeight = (theme, orientation) => {
  const isLandscape = document.documentElement.clientWidth > document.documentElement.clientHeight;
  if (orientation === 'landscape') {
    if (isLandscape) return document.querySelector('#root').getBoundingClientRect().height;
    return document.querySelector('#root').getBoundingClientRect().width;
  }
  if (isLandscape) return document.querySelector('#root').getBoundingClientRect().width;
  return document.querySelector('#root').getBoundingClientRect().height;
};
const styles = (theme) => ({
  fullscreenPortal: {
    background: 'white',
    position: 'absolute',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    zIndex: 11,
    top: 0,
    left: 0,
  },

  toolbarHeaderWrapper: {
    background: 'transparent',
    '& .MuiTypography-root': {
      lineHeight: '36px !important',
    },
    padding: theme.spacing(0, 3),
    minHeight: theme.layout.appbar.heightSm,
    maxHeight: theme.layout.appbar.heightSm,
    [theme.breakpoints.up('sm')]: {
      minHeight: theme.layout.appbar.height,
      maxHeight: theme.layout.appbar.height,
      padding: theme.spacing(0, 6),
    },
    [theme.breakpoints.up('xl')]: {
      minHeight: theme.layout.appbar.heightXL,
      maxHeight: theme.layout.appbar.heightXL,
      padding: theme.spacing(0, 6),
    },

  },
  closeButton: {
    paddingTop: 2,
    height: 48,
    borderRadius: 100,
    //  textTransform: 'lowercase',
    marginLeft: 'auto',
    padding: 0,
    '&:hover, &:active, &:focus': {
      background: 'transparent',
    },
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 5,
      marginRight: -22,
      paddingRight: 17,
      '&:hover': {
        background: '#F2F2F2',
      },
      '&:focus,&:active': {
        background: '#C9C9C9',
      },
    },
    '& .MuiButton-label': {
      color: 'black',
      marginRight: -8,
      marginLeft: 'auto',
      width: 36,
      height: 36,
      borderRadius: 100,
      '&:hover': {
        background: '#F2F2F2',
        [theme.breakpoints.up('sm')]: {
          background: 'transparent',
        },
      },
      ' &:active, &:focus': {
        background: '#C9C9C9',
        [theme.breakpoints.up('sm')]: {
          background: 'transparent',
        },
      },
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
        marginRight: 0,
        height: 1,
        marginLeft: 0,
      },
      [theme.breakpoints.up('xl')]: {
        minHeight: 1,
      },
      '& > span': {
        marginLeft: theme.layout.buttonIcon.paddingLeft + 4,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'inherit',
        },
      },
    },
    '& .MuiSvgIcon-root': {
      fill: 'black',

      minWidth: '24px !important',
      height: theme.layout.appbar.heightSm - theme.spacing(4),
      width: 'auto',
      padding: theme.spacing(2, 0),
      [theme.breakpoints.up('sm')]: {
        marginRight: -5.5,
        height: theme.layout.appbar.height - 15,
      },
      [theme.breakpoints.up('xl')]: {
        minHeight: theme.layout.appbar.height - 15,
      },
    },
  },
  visualizationWrapperThumbs: {
    height: 'calc(100% - 47px - 47px - 47px  - 47px - 134px )',
    maxHeight: 'calc(100% - 47px - 47px - 47px  - 47px - 134px )',
    position: 'relative',
    top: 134,
    [theme.breakpoints.up('sm')]: {
      top: 87,
      height: 'calc(100% - 60px - 20px - 127px)',
      maxHeight: 'calc(100% - 60px - 20px - 127px )',

    },
    [theme.breakpoints.up('xl')]: {
      top: 130,
      height: 'calc(100% - 60px  - 220px)',
      maxHeight: 'calc(100% - 60px - 220px )',
    },
  },
  visualizationWrapperCanvas: {
    height: '100% ',
  },
  thumbNailsWrapper: {
    width: '100%',
    position: 'absolute',
    bottom: 'calc(7vh + 151px)', // (getHeight(theme, "portrait")  -166-theme.layout.footerbar.heightSm *3)/2 - 58 *1.5 ,
    [theme.orientation.landscape]: {
      // bottom: (getHeight(theme, "landscape")  -166-theme.layout.footerbar.heightSm *3)/2 - 58*2 ,
    },
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 38,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      bottom: `calc(23vh + ${70}px)`, // (getHeight(theme, "portrait")  -166-theme.layout.footerbar.heightSm *3)/2 - 58 *1.5 ,

      [theme.orientation.landscape]: {
        bottom: `calc(16vh + ${70}px)`, // (getHeight(theme, "portrait")  -166-theme.layout.footerbar.heightSm *3)/2 - 58 *1.5 ,

      },
    },

  },
  previewText: {
    fontWeight: 'bold',
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'initial',
    },
  },
  thumbNails: {
    width: '100%',
    padding: '0px 18px',
    minWidth: 180,
    marginRight: 0,
    [theme.breakpoints.up('sm')]: {
      marginRight: 90,
      width: 'auto',
    },
  },

});

class PreviewPortal extends React.Component {
    static propTypes = {
      thumbnailClick: PropTypes.func,
      thumbnails: PropTypes.array,
      closePreviewMode: PropTypes.func,
      classes: PropTypes.object,
      width: PropTypes.string,
      dialogStyle: PropTypes.string,
      hasItems: PropTypes.bool,
      alignTarget: PropTypes.shape({ add: PropTypes.func.isRequired, remove: PropTypes.func.isRequired })
        .isRequired,
      children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    };

    componentDidMount() {
      this.props.alignTarget.add(this.wrapperRef.current);
    }

    componentWillUnmount() {
      this.props.alignTarget.remove(this.wrapperRef.current);
    }

    wrapperRef = React.createRef();

    onThumbnailClick = () => (thumbnails, src, active) => {
      if (isFunction(this.props.thumbnailClick)) {
        this.props.thumbnailClick(thumbnails, src, active);
      }
    };

    renderPreview() {
      const {
        hasItems, closePreviewMode, classes, children, width, dialogStyle,
      } = this.props;
      const portalStyle = dialogStyle
        ? `${classes.fullscreenPortal} ${dialogStyle}`
        : classes.fullscreenPortal;

      return (
        <div className={portalStyle}>
          <div
            className={classes.appbar}
          >
            <Toolbar classes={{ regular: classes.toolbarHeaderWrapper }}>

              <TitleDisplay />
              <Button disableRipple className={classes.closeButton} color="inherit" onClick={closePreviewMode}>
                <span>
                  {t('general.closeLabel')}
                </span>
                <CloseMenuIcon />

              </Button>
            </Toolbar>
          </div>
          <div
            ref={this.wrapperRef}
            className={
                        hasItems ? classes.visualizationWrapperThumbs : classes.visualizationWrapperCanvas
                    }
          >
            {children}
          </div>
          {hasItems && (
          <div className={classes.thumbNailsWrapper}>
            <Typography variant="body2" className={classes.previewText}>{t('fullscreenView.moreViews')}</Typography>
            <div className={classes.thumbNails}>
              <Thumbnails previewOpen />
            </div>
          </div>
          )}
          <AnalyticsWrapper targetId="preview_close">
            <Grid
              container
              alignItems="center"
              justify="center"
            />
          </AnalyticsWrapper>
        </div>
      );
    }

    render() {
      return ReactDOM.createPortal(this.renderPreview(), document.getElementById('frame'));
    }
}

export default withWidth()(withStyles(styles, { name: 'Portal' })(withAlignTarget(PreviewPortal)));
